import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";

export default function PackingListWorkflowTableLoading() {
  return (
    <div className="rfv2-packing-list__workflow-config-loading" aria-busy="true" aria-live="polite">
      <LoadingSkeleton rows={2} bodyClasses="p-0" className="p-4" noShadow />
    </div>
  );
}
